import { CONSULTATION_TYPE } from '@abiglobalhealth/go-types'

import { PrescriptionForm } from '@/components/Consultation/steps/PrescriptionForm'
import { useConsultationType } from '@/hooks/useConsultationType'

import { InputForm } from './InputForm'
import { MentalForm } from './MentalForm'

export const Landing = () => {
  const { consultationType } = useConsultationType()

  let FormComponent = <InputForm />
  if (consultationType === CONSULTATION_TYPE.PRESCRIPTION) {
    FormComponent = <PrescriptionForm />
  } else if (consultationType === CONSULTATION_TYPE.MENTAL) {
    FormComponent = <MentalForm />
  }

  return (
    <div className="animate-fade-in flex flex-1 flex-col p-4" data-testid="landing-container">
      {FormComponent}
    </div>
  )
}
